function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);}var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { useEffect, useState } from 'react';
import { useLoaderData, useRevalidator } from 'react-router';
import { useAtomValue, useSetAtom } from 'jotai';
import { Translate } from "../../../../I18N";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { Button } from "../../../Components/UI";
import { notificationAtom, templatesAtom } from "../../../atoms";

import { EntityStatus } from "../../../shared/ParagraphExtractionTypes";
import * as entitiesAPI from "../../../api/paragraphExtractor/entities";
import { EntitiesTable } from "./components/entities/Table";
import { generateDisplayPill } from "./utils/generateDisplayPill";
import { ExtractEntitiesDialog } from "./components/entities/ExtractEntitiesDialog";
import { EntityFilterSidepanel } from "./components/FilterSidePanel/EntityFilterSidepanel";
import { filterSidepanelStatusAtom } from "./components/FilterSidePanel/filterSidepanelAtom";

const DisplayPill = generateDisplayPill({
  label: 'New'
});

const POLL_INTERVAL_SECONDS = 25;

const PXEntityDashboard = () => {
  const revalidator = useRevalidator();
  const templates = useAtomValue(templatesAtom);
  const { rows, totalRows, extractor, page } = useLoaderData();
  const setFilterSidepanelStatus = useSetAtom(filterSidepanelStatusAtom);
  const sourceTemplate = templates.find((template) => template._id === (extractor === null || extractor === void 0 ? void 0 : extractor.sourceTemplateId));
  const setNotifications = useSetAtom(notificationAtom);
  const [data, setData] = useState(rows);
  const [isSaving, setIsSaving] = useState(false);
  const [selected, setSelected] = useState([]);
  const previousPageRef = React.useRef(page);
  const newEntitiesCount = data.filter((row) => row.status.status === EntityStatus.New).length;

  const handleExtract = async () => {
    setIsSaving(true);

    try {
      if (!extractor) {
        setNotifications({
          type: 'error',
          text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
          details: /*#__PURE__*/_jsx(Translate, {}, void 0, "Cannot find extractor")
        });
      } else {
        await entitiesAPI.extractParagraphs(extractor === null || extractor === void 0 ? void 0 : extractor._id);
        await revalidator.revalidate();
        setNotifications({
          type: 'success',
          text: /*#__PURE__*/
          _jsx(Translate, {}, void 0, "The process of extracting the paragraphs has successfully started. Check the Status column for updates on the process."


          )

        });
        await revalidator.revalidate();
      }
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred")
      });
    }

    setIsSaving(false);
  };

  useEffect(() => {
    setFilterSidepanelStatus((extractor === null || extractor === void 0 ? void 0 : extractor.statusCount) || {});

    if (page !== previousPageRef.current) {
      setData(rows);
      previousPageRef.current = page;
    } else {
      setData((prevRows) =>
      prevRows.map((row) => {var _rows$find;
        const newStatus = (_rows$find = rows.find((r) => r.entity._id === row.entity._id)) === null || _rows$find === void 0 ? void 0 : _rows$find.status;
        if (newStatus && newStatus.status !== row.status.status) {
          // Only reassign if status changed
          // eslint-disable-next-line no-param-reassign
          row.status = _objectSpread({}, newStatus);
        }
        return row;
      })
      );
    }
  }, [extractor === null || extractor === void 0 ? void 0 : extractor.statusCount, page, rows, setFilterSidepanelStatus]);

  useEffect(() => {
    const interval = setInterval(async () => {
      await revalidator.revalidate();
    }, POLL_INTERVAL_SECONDS * 1000);

    return () => clearInterval(interval);
    // Only run this effect once
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (/*#__PURE__*/
    _jsx("div", { className: "h-full w-full overflow-y-auto", "data-testid": "settings-paragraph-extractor" }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, {
      title: sourceTemplate === null || sourceTemplate === void 0 ? void 0 : sourceTemplate.name,
      contextId: sourceTemplate === null || sourceTemplate === void 0 ? void 0 : sourceTemplate._id,
      path: new Map([['Paragraph extraction', '/settings/paragraph-extraction']]) }
    ), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(EntitiesTable, {
      pxEntitiesData: data,
      onSelectionChange: setSelected,
      sourceTemplate: sourceTemplate,
      totalRows: totalRows,
      initialSelection: selected }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: "flex gap-2", highlighted: (selected === null || selected === void 0 ? void 0 : selected.length) > 0 }, void 0,
    (selected === null || selected === void 0 ? void 0 : selected.length) === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      className: "disabled:opacity-50",
      onClick: handleExtract,
      disabled: !newEntitiesCount || isSaving }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Extract new paragraphs")
    ),
    Boolean(newEntitiesCount) && /*#__PURE__*/_jsx(DisplayPill, { count: newEntitiesCount })
    ),

    (selected === null || selected === void 0 ? void 0 : selected.length) > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex items-center gap-2" }, void 0, /*#__PURE__*/
    _jsx(ExtractEntitiesDialog, {
      setIsProcessing: setIsSaving,
      onSuccess: async () => {
        setSelected([]);
        await revalidator.revalidate();
      },
      selected: selected,
      disabled: isSaving }
    ), /*#__PURE__*/
    _jsx("div", { className: "text-gray-500" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), ' ', /*#__PURE__*/
    _jsx("span", { className: "font-semibold text-gray-900" }, void 0, selected.length), ' ', /*#__PURE__*/
    _jsx(Translate, {}, void 0, "of"), ' ', /*#__PURE__*/
    _jsx("span", { className: "font-semibold text-gray-900" }, void 0, totalRows)
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(EntityFilterSidepanel, {})
    ));

};

export { PXEntityDashboard };